import { render, staticRenderFns } from "./mutilSelect.vue?vue&type=template&id=5b4e220f&scoped=true"
import script from "./mutilSelect.vue?vue&type=script&lang=js"
export * from "./mutilSelect.vue?vue&type=script&lang=js"
import style0 from "./mutilSelect.vue?vue&type=style&index=0&id=5b4e220f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4e220f",
  null
  
)

export default component.exports